import React, { useState } from 'react';
import { Modal, SparkModalPortal, Spinner } from '@spark';
import { TrainFromSpecificUsecase } from './TrainFromSpecificUsecase';

/**
 * Kebab "Retrain" dialog: the Model Summary tab view (summary + Advanced)
 * plus the same Let's Train action (Figma 3173:7654). Also serves the
 * first-run "Train" primary button (a task with data but no completed
 * version yet), which passes `title="Train"`.
 */
export const RetrainTaskModal = ({
    open,
    onClose,
    title = 'Retrain',
    moveToScreen,
    onDataOverviewRefresh,
    onTrainingStarted,
}) => {
    const [trainAction, setTrainAction] = useState(null);

    const handleTrainingStarted = () => {
        onClose?.();
        onTrainingStarted?.();
    };

    return (
        <SparkModalPortal open={open} onClose={onClose} size="wide" destroyOnClose>
            <Modal
                title={title}
                showSubtitle={false}
                primaryLabel={trainAction?.loading ? 'Training…' : "Let's Train"}
                primaryIcon={trainAction?.loading ? <Spinner size="small" /> : undefined}
                primaryDisabled={!!trainAction?.disabled || !!trainAction?.loading}
                primaryDisableWhenReadOnly
                tertiaryLabel="Cancel"
                onPrimaryClick={() => {
                    void trainAction?.onClick?.();
                }}
                onTertiaryClick={onClose}
                onCloseClick={onClose}
            >
                {open ? (
                    <TrainFromSpecificUsecase
                        layout="summary-modal"
                        embeddedInTaskDrawer
                        moveToScreen={moveToScreen}
                        onDataOverviewRefresh={onDataOverviewRefresh}
                        onTrainActionChange={setTrainAction}
                        onTrainingStarted={handleTrainingStarted}
                        onNavigateAway={onClose}
                    />
                ) : null}
            </Modal>
        </SparkModalPortal>
    );
};

export default RetrainTaskModal;
